import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import noDataAnim from "../../assets/no-data-anim.webp";

export const AI_HUB_SCOPE_EMPTY_MESSAGE =
  "Choose an Object Type and Object Sub-Type from the filters above to load the results";

export const AI_HUB_NO_RESULTS_MESSAGE = "No results";

const emptyTextSx = {
  color: "#8c8c8c",
  fontSize: 14,
  textAlign: "center",
  maxWidth: 480,
} as const;

type AiHubNoRowsOverlayProps = Readonly<{
  hasScopeSelection: boolean;
}>;

export default function AiHubNoRowsOverlay({
  hasScopeSelection,
}: AiHubNoRowsOverlayProps) {
  return (
    <Box
      sx={{
        height: "100%",
        minHeight: 280,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.paper",
        px: 2,
      }}
    >
      <Box component="img" src={noDataAnim} alt="" sx={{ width: 160, mb: 2 }} />
      <Typography sx={emptyTextSx}>
        {hasScopeSelection
          ? AI_HUB_NO_RESULTS_MESSAGE
          : AI_HUB_SCOPE_EMPTY_MESSAGE}
      </Typography>
    </Box>
  );
}
